/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The type of RdSAP report.
 */
export type ReportType = 'EPR' | 'EPC';

export const ReportType = {
    Epr: 'EPR' as ReportType,
    Epc: 'EPC' as ReportType
};

